import { EventEmitter } from 'events';
export default new EventEmitter();

export const Events = {
  login: Symbol(),
  logout: Symbol(),
  loginShow: Symbol(),
  loginCancel: Symbol()
};